import React, {useRef, useState} from "react";
import {useField, useFormikContext} from "formik";

import styles from './styles.module.scss'
import { Dropdown } from "../";
import {useOnClickOutside} from "../../hooks/useOnClickOutside";

export const FieldDropdown = ({...props}) => {
  const { setFieldValue } = useFormikContext();
  const ref = useRef();
  const [field, meta] = useField(props);

  const [toggleDropdown, setToggleDropdown] = useState(false);

  const { options } = props;

  //console.log('options', options);

  //Classes
  const cls = [styles.field__input];
  const clsGroup = [styles.field__group];
  if (meta.touched && meta.error) {
    cls.push(styles.field__input_error)
  }

  if (toggleDropdown) {
    clsGroup.push(styles.field__group_opened);
  }
  //END Classes

  //const error = meta.touched && meta.error && <div className={styles.field__error}>{meta.error}</div>;

  // Handlers
  const handleItemClick = (e, item) => {
    e.preventDefault();
    setFieldValue(field.name, item);
    setToggleDropdown(!toggleDropdown);
  };

  const handleInputClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setToggleDropdown(!toggleDropdown);
  };

  const handleToggleDropdown = (e) => {
    e.preventDefault();
    setToggleDropdown(!toggleDropdown);
  };

  useOnClickOutside(ref, () => setToggleDropdown(false));

  return (
    <div className={styles.field} ref={ref}>
      <div className={clsGroup.join(' ')}>
        <label className={styles.field__label} htmlFor={props.id}>{props.label}</label>
        <input
          className={cls.join(' ')}
          { ...field }
          { ...props }
          onClick={handleInputClick}
          readOnly
        />
        <button className={styles.field__toggle_dropdown} onClick={handleToggleDropdown}><span className="ico-down"></span></button>
        {
          toggleDropdown && <Dropdown list={options} handleClick={handleItemClick} />
        }
      </div>
      {/*{ error }*/}
    </div>
  )
};
